import React, { useState, useEffect } from 'react';
import { Plus, Edit2, Wifi, CheckCircle, XCircle, Server } from 'lucide-react';
import api from '../services/api';

const TIPOS_SISTEMA = ['hubsoft', 'ixc', 'sgp', 'outro'];

const CAMPOS_VALORES = [
    { key:'taxa_mudanca_endereco', label:'Taxa mudanca de endereco', ph:'ex: R$50 na proxima fatura' },
    { key:'taxa_visita_fibra', label:'Taxa visita tecnica (fibra)', ph:'ex: R$30' },
    { key:'taxa_visita_utp', label:'Taxa visita tecnica (UTP)', ph:'ex: R$20' },
    { key:'taxa_realocacao', label:'Taxa realocacao', ph:'ex: R$50' },
    { key:'dias_vencimento', label:'Dias de vencimento', ph:'ex: 05/10/15/20/25/ultimo' },
    { key:'max_dias_suspensao', label:'Max. suspensao temporaria', ph:'ex: 90 dias' },
    { key:'telefone_cancelamento', label:'Telefone cancelamento', ph:'ex: (21) 3513-5978' },
    { key:'horario_cancelamento', label:'Horario cancelamento', ph:'ex: seg-sex 8h-17h' },
    { key:'url_central', label:'URL central do assinante', ph:'ex: central.exemplo.com.br' },
    { key:'ip_fixo', label:'IP fixo', ph:'ex: sob consulta - confirmar com a equipe' },
];

export default function Isps() {
    const [isps, setIsps] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editing, setEditing] = useState(null);
    const [loading, setLoading] = useState(false);

    const emptyForm = { nome:'', slug:'', tipo_sistema:'hubsoft', ativo:true, valores:{}, planosText:'' };
    const [form, setForm] = useState(emptyForm);

    useEffect(() => { load(); }, []);

    const load = async () => {
        try { const r = await api.get('/api/isps'); setIsps(r.data); } catch(e) { console.error(e); }
    };

    const openNew = () => { setEditing(null); setForm(emptyForm); setShowModal(true); };

    const openEdit = (isp) => {
        setEditing(isp);
        const v = isp.valores || {};
        const planos = Array.isArray(v.planos) ? v.planos : [];
        setForm({
            nome: isp.nome || '', slug: isp.slug || '',
            tipo_sistema: isp.tipo_sistema || 'hubsoft', ativo: isp.ativo, valores: v,
            planosText: planos.map(p => p.nome + ' | ' + p.valor).join('\n')
        });
        setShowModal(true);
    };

    const setValor = (key, val) => setForm(f => ({ ...f, valores: { ...f.valores, [key]: val } }));

    const buildValores = () => {
        const v = { ...form.valores };
        const planos = form.planosText.split('\n').map(l => l.trim()).filter(Boolean).map(l => {
            const idx = l.lastIndexOf('|');
            if (idx === -1) return { nome: l, valor: '' };
            return { nome: l.slice(0, idx).trim(), valor: l.slice(idx+1).trim() };
        });
        if (planos.length) v.planos = planos; else delete v.planos;
        return v;
    };

    const save = async () => {
        if (!form.nome || !form.slug) { alert('Nome e slug sao obrigatorios'); return; }
        setLoading(true);
        try {
            const valores = buildValores();
            if (editing) {
                await api.put('/api/isps/' + editing.id, { nome: form.nome, tipo_sistema: form.tipo_sistema, valores, ativo: form.ativo });
            } else {
                await api.post('/api/isps', { nome: form.nome, slug: form.slug, tipo_sistema: form.tipo_sistema, valores, ativo: form.ativo });
            }
            setShowModal(false); await load();
        } catch(e) { alert((e.response && e.response.data && e.response.data.error) || e.message); }
        finally { setLoading(false); }
    };

    const toggle = async (isp) => {
        try { await api.patch('/api/isps/' + isp.id + '/toggle'); await load(); }
        catch(e) { alert((e.response && e.response.data && e.response.data.error) || e.message); }
    };

    return (
        <div style={{ padding:32, marginLeft:240 }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
                <div style={{ display:'flex', alignItems:'center', gap:12 }}><Wifi size={26}/><h1 style={{ margin:0, fontSize:24 }}>ISPs</h1></div>
                <button onClick={openNew} style={btnPrimary}><Plus size={18}/> Nova ISP</button>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(320px, 1fr))', gap:16 }}>
                {isps.map(isp => (
                    <div key={isp.id} style={card}>
                        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                            <div><div style={{ fontSize:18, fontWeight:600 }}>{isp.nome}</div><div style={{ fontSize:13, color:'var(--text-secondary)' }}>/{isp.slug}</div></div>
                            <span onClick={()=>toggle(isp)} style={{ cursor:'pointer', display:'flex', alignItems:'center', gap:4, fontSize:13, color: isp.ativo ? '#16a34a' : '#9ca3af' }}>
                                {isp.ativo ? <CheckCircle size={16}/> : <XCircle size={16}/>}{isp.ativo ? 'Ativo' : 'Inativo'}
                            </span>
                        </div>
                        <div style={{ display:'flex', gap:12, marginTop:12, fontSize:13, color:'var(--text-secondary)' }}>
                            <span style={{ display:'flex', alignItems:'center', gap:4 }}><Server size={14}/> {isp.tipo_sistema}</span>
                            <span>{isp.agentes} agente(s)</span>
                            <span>{Array.isArray(isp.valores && isp.valores.planos) ? isp.valores.planos.length : 0} plano(s)</span>
                        </div>
                        <button onClick={()=>openEdit(isp)} style={{ ...btnGhost, marginTop:14 }}><Edit2 size={15}/> Editar</button>
                    </div>
                ))}
                {isps.length === 0 && (<div style={{ color:'var(--text-secondary)' }}>Nenhuma ISP cadastrada.</div>)}
            </div>
            {showModal && (
                <div style={overlay} onClick={()=>setShowModal(false)}>
                    <div style={modal} onClick={e=>e.stopPropagation()}>
                        <h2 style={{ marginTop:0 }}>{editing ? 'Editar ISP' : 'Nova ISP'}</h2>
                        <label style={lbl}>Nome</label>
                        <input style={inp} value={form.nome} onChange={e=>setForm(f=>({...f, nome:e.target.value}))} placeholder="ex: Mobly Fibra"/>
                        <label style={lbl}>Slug {editing && <span style={{ color:'var(--text-secondary)', fontWeight:400 }}>(nao editavel)</span>}</label>
                        <input style={{...inp, opacity: editing ? 0.6 : 1}} value={form.slug} disabled={!!editing} onChange={e=>setForm(f=>({...f, slug:e.target.value}))} placeholder="ex: mobly"/>
                        <label style={lbl}>Sistema</label>
                        <select style={inp} value={form.tipo_sistema} onChange={e=>setForm(f=>({...f, tipo_sistema:e.target.value}))}>{TIPOS_SISTEMA.map(t => <option key={t} value={t}>{t}</option>)}</select>
                        <div style={{ borderTop:'1px solid var(--border)', margin:'18px 0 10px', paddingTop:14, fontWeight:600 }}>Valores configuraveis</div>
                        {CAMPOS_VALORES.map(c => (
                            <div key={c.key}>
                                <label style={lbl}>{c.label}</label>
                                <input style={inp} value={form.valores[c.key] || ''} placeholder={c.ph} onChange={e=>setValor(c.key, e.target.value)}/>
                            </div>
                        ))}
                        <label style={lbl}>Planos (um por linha: nome | valor)</label>
                        <textarea style={{...inp, minHeight:120, fontFamily:'monospace', fontSize:13}} value={form.planosText} onChange={e=>setForm(f=>({...f, planosText:e.target.value}))} placeholder={"600Mb - Internet | R$99,90\n900Mb - Internet | R$119,90"}/>
                        <label style={{ display:'flex', alignItems:'center', gap:8, marginTop:14, cursor:'pointer' }}>
                            <input type="checkbox" checked={form.ativo} onChange={e=>setForm(f=>({...f, ativo:e.target.checked}))}/> ISP ativa
                        </label>
                        <div style={{ display:'flex', gap:10, marginTop:22, justifyContent:'flex-end' }}>
                            <button onClick={()=>setShowModal(false)} style={btnGhost}>Cancelar</button>
                            <button onClick={save} disabled={loading} style={btnPrimary}>{loading ? 'Salvando...' : 'Salvar'}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

const btnPrimary = { display:'flex', alignItems:'center', gap:6, background:'var(--accent, #2563eb)', color:'#fff', border:'none', borderRadius:8, padding:'10px 16px', cursor:'pointer', fontSize:14 };
const btnGhost = { display:'flex', alignItems:'center', gap:6, background:'transparent', color:'var(--text-primary)', border:'1px solid var(--border)', borderRadius:8, padding:'8px 14px', cursor:'pointer', fontSize:14 };
const card = { background:'var(--bg-secondary)', border:'1px solid var(--border)', borderRadius:12, padding:18 };
const overlay = { position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'flex-start', justifyContent:'center', padding:'40px 20px', overflowY:'auto', zIndex:1000 };
const modal = { background:'var(--bg-primary, #fff)', borderRadius:14, padding:28, width:'100%', maxWidth:560 };
const lbl = { display:'block', fontSize:13, fontWeight:500, margin:'12px 0 4px' };
const inp = { width:'100%', boxSizing:'border-box', padding:'9px 12px', borderRadius:8, border:'1px solid var(--border)', background:'var(--bg-primary)', color:'var(--text-primary)', fontSize:14 };
